import queryString from 'query-string';
import { get } from './apiUtils';

const defaultUrl = '/OrderActions/';

export default {
  getOrderActions: ({ id, query } = {}) =>
    get(`${defaultUrl}${id || ''}${query ? '?'.concat(queryString.stringify(query)) : ''}`),
};
